const supportedCurrenciesMap = new Map<string, boolean>()

const isSupportedCurrency = (currency: string, locale = 'en'): boolean => {
  try {
    const numberFormat = new Intl.NumberFormat(locale, {
      style: 'currency',
      currencyDisplay: 'name',
      currency,
    })

    const format = numberFormat.format(123)

    if (format.substring(0, 3) !== currency && format.substring(format.length - 3) !== currency) {
      return true
    }
    // eslint-disable-next-line no-empty
  } catch (_err) {}

  return false
}

export const checkIntlSupportedCurrencyPolyfill = (currency: string, locale = 'en') => {
  if (!currency) {
    return false
  }

  const currencyKey = currency.toUpperCase()
  let isSupported = supportedCurrenciesMap.get(currencyKey)

  if (isSupported == null) {
    isSupported = isSupportedCurrency(currencyKey, locale)
    supportedCurrenciesMap.set(currencyKey, isSupported)
  }

  return isSupported
}
